const availableFeatures = [
  'blackoutScreen',
  'disableBlackoutScreen',
  'allowSaleOffers',
  'allowWinASlice',
  'allowSpinToWin',
  'welcomeBonusNotification',
  'discountOfferOnSignUp',
  'percentOffFoodVoucherNotification',
  'allowJet2holidays',
  'amountOffFoodVoucherNotification',
  'allowOfferInWalletNotification',
] as const;

export default availableFeatures;

export type AvailableFeatures = typeof availableFeatures[number];
